import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaConfiguracionPagos', NominasNominaConfiguracionPagos)

function NominasNominaConfiguracionPagos($http) {
  this.get = function (idProyecto, idNomina, idTipoPago) {
    return $http.get('/api/nominas/nomina/configuracion/pagos', {
      params: {
        id_proyecto: idProyecto,
        id_nomina: idNomina,
        id_tipo_pago: idTipoPago,
      },
      schema: this.schema,
    })
  }.bind(this)

  this.put = function (idProyecto, idNomina, idTipoPago, data) {
    return $http.put('/api/nominas/nomina/configuracion/pagos', data, {
      params: {
        id_proyecto: idProyecto,
        id_nomina: idNomina,
        id_tipo_pago: idTipoPago,
      },
      schema: this.schema,
      clearCache: 'nominas',
    })
  }.bind(this)

  this.schema = {
    cuentas_bancarias: {
      id_moneda: 'number',
    },
    id_moneda: 'number',
    id_dispersion: 'number',
    pagos: {
      id_moneda: 'number',
      id_metodo_pago: 'number',
      id_pago: 'number',
      importe: 'number',
      indice: 'number',
      eliminable: 'boolean',
      editable: 'boolean',
      eliminado: 'boolean',
      modificado: 'boolean',
      status_pagado: 'boolean',
      status_timbrado: 'boolean',
      tipo_cambio: 'number',
    },
    status_aprobado: 'boolean',
    status_timbrado: 'boolean',
    tipo_cambio: 'number',
    total: 'number',
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Configuracion/Pagos.js